module.exports = __webpack_public_path__ + "static/media/ubelens-logo-color.d96d4888.png";